import { render, staticRenderFns } from "./VehiculosPersonal.vue?vue&type=template&id=645b6452"
import script from "./VehiculosPersonal.vue?vue&type=script&lang=js"
export * from "./VehiculosPersonal.vue?vue&type=script&lang=js"
import style0 from "./VehiculosPersonal.vue?vue&type=style&index=0&id=645b6452&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports